import { render, staticRenderFns } from "./yiqiaoyidang.vue?vue&type=template&id=9987f714&"
import script from "./yiqiaoyidang.vue?vue&type=script&lang=js&"
export * from "./yiqiaoyidang.vue?vue&type=script&lang=js&"
import style0 from "./yiqiaoyidang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports